import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { getProduct } from '../../api/services/product/getproduct';
import Loader from './../Common Utility/Loader';
import { CartContext } from '../Cart Utility/CartManager'; // Import the Cart context
import './ProductDetail.css';

const ProductDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const cart = useContext(CartContext); // Use the Cart context
    

    useEffect(() => {
        const fetchProduct = async () => {
            setLoading(true);
            try {
                const response = await getProduct(id);
                setProduct(response || {});
                setError(null);
            } catch (err) {
                setError('Product not found');
                setProduct(null);
            } finally {
                setLoading(false);
            }
            
        };
        
        fetchProduct();
    }, [ id]);

    
    const addToCart = () => {
        localStorage.setItem('cart', JSON.stringify([...cart.items, product])); // Persist cart to localStorage
        cart.setItems([...cart.items, product]);
        
        // alert(`${product.title} has been added to your cart.`);
    };

    const handleCheckout = () => {
        if (cart.itemslength === 0) {
            alert('Your cart is empty. Please add items to your cart before checking out.');
            return;
        }
        navigate('/checkout'); // Redirect to the checkout page
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return (
            <div className="error-container">
                <p>{error}</p>
                <button onClick={() => window.location.reload()}>Retry</button>
            </div>
        );
    }

    return (
            <div className="product-detail-container">
                {product ? (
                    <>
                        <div className="product-detail-header">
                            <h1 className="product-name">{product.title}</h1>
                        </div>
                        <div className="product-detail-content">
                            <img
                                src={product.images}
                                alt={product.title}
                                className="product-image"
                                loading="lazy"
                            />
                            <div className="product-info">
                                <p className="product-description">{product.description}</p>
                                <p className="product-price">Price: ${(product.price*1)?.toFixed(2)}</p>
                                <button className="add-to-cart-button" onClick={addToCart}>
                                    Add to Cart
                                </button>
                                <button className="checkout-button" onClick={handleCheckout}>
                                    Checkout
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    <p className="no-product-message">Product details are not available.</p>
                )}
            </div>
    );
};

export default ProductDetail;